import React from 'react'
import { FormGroup } from '@theneatcompany/nui'

import { useSignUp } from '@/components/Providers/SignUpProvider'
import Yup from '@/utils/yup'
import Form from '@/components/forms/Form'
import InputField from '@/components/forms/InputField'
import { Button, Text } from '@/components/common'
import PasswordInputField from '@/components/forms/PasswordInputField'

import SignUpLayout from './SignUpLayout'
import styles from './SignUp.module.scss'
import FormBox from './FormBox'

const getMessageId = id => `pages.signUp.form.existingUser.${id}`

const ExistingUser = () => {
  const {
    user,
    saveStepExistingUser,
    failedAuth,
    canPurchasePlan,
    requirePassword,
    handleForgotPassword,
    isRequestingPasswordReset,
  } = useSignUp()

  const schema = Yup.object({
    email: Yup.string().trim(),
    password: requirePassword() ? Yup.string().trim().required() : Yup.string(),
  })

  const loginMessaging = () => {
    let message = 'Please enter your password to continue.'
    if (!canPurchasePlan) {
      if (user.googleId) {
        message = 'Please click below to log in to Neat. You can view and manage your subscription from the My Subscription setting within the app.'
      } else {
        message = 'Please enter your password below to log in to Neat. You can view and manage your subscription from the My Subscription setting within the app.'
      }
    }

    return message
  }

  return (
    <SignUpLayout split={false}>
      <FormBox shouldCalculateMargin={false}>
        <Text.P
          center
          ellipsized
          messageProps={{
            id: getMessageId('greeting'),
            values: {
              email: user.email,
            },
          }}
          noMargin
          size="large"
        />
        <Text.P center messageId={getMessageId('welcomeBack')} noMargin size="small" />
        <Text.P center noMargin size="small">
          {loginMessaging()}
        </Text.P>
        <div className="text-center">
          <Form initialValues={{ email: user.email, password: '' }} onSubmit={saveStepExistingUser} schema={schema}>
            <InputField
              containerProps={{ noMargin: true }}
              disabled
              hidden
              labelProps={{ hidden: true }}
              name="email"
              value={user.email}
            />
            {requirePassword() && (
            <PasswordInputField
              className={failedAuth ? styles.passwordInvalid : ''}
              shouldDisplayErrorMessage={!failedAuth}
            />
            )}
            {failedAuth &&
            <FormGroup.HelperText className={styles.formError}>{failedAuth}</FormGroup.HelperText>}
            <Form.Action
              className={styles.submit}
              data-testid={`welcomeback-${!canPurchasePlan ? 'login' : 'continue'}-cta`}
              disabled={isRequestingPasswordReset}
              messageId={!canPurchasePlan ? 'cta.login' : 'cta.continue'}
              size="large"
              type="submit"
            />
          </Form>
          {requirePassword() && (
          <Button
            disabled={isRequestingPasswordReset}
            messageId={getMessageId('resetPassword')}
            onClick={handleForgotPassword}
            size="xsmall"
            variant="link"
          />)}
        </div>
      </FormBox>
    </SignUpLayout>
  )
}

export default ExistingUser
